import React from 'react';
import { Route } from '../Routing/types';
import {
  PATH_TRACKER,
  PATH_TRACKER_SETTINGS,
  PATH_TRACKER_SETTINGS_MACRO,
  PATH_TRACKER_MEAL,
  PATH_TRACKER_ADD_INGREDIENT,
  PATH_TRACKER_ADD_INGREDIENT_SCAN_BARCODE,
  PATH_TRACKER_DESCRIBE_MEAL,
  PATH_TRACKER_DESCRIBE_MANUAL_MEAL,
  PATH_TRACKER_DESCRIBE_MEAL_VOICE,
  PATH_TRACKER_DESCRIBE_ADD_INGREDIENT,
  PATH_TRACKER_DESCRIBE_ADD_INGREDIENT_SCAN_BARCODE,
  PATH_TRACKER_DESCRIBE_MEAL_MEAL,
  PATH_TRACKER_DESCRIBE_ACTIVITY,
  PATH_TRACKER_DESCRIBE_ACTIVITY_VOICE,
  PATH_TRACKER_DESCRIBE_ACTIVITY_ACTIVITY_DETAILS,
  PATH_TRACKER_EDIT_ACTIVITY,
  PATH_TRACKER_SCAN_PLATE,
  PATH_TRACKER_SCAN_PLATE_DETAILS,
  PATH_TRACKER_SCAN_BARCODE,
  PATH_TRACKER_UPLOAD_IMAGE,
  PATH_TRACKER_ADD_PRODUCT,
  PATH_TRACKER_SCAN_LABEL,
  PATH_TRACKER_SCAN_LABEL_ANALYZING,
  PATH_TRACKER_ADD_INGREDIENT_ADD_PRODUCT,
  PATH_TRACKER_ADD_INGREDIENT_ADD_PRODUCT_SCAN_LABEL,
  PATH_TRACKER_ADD_INGREDIENT_ADD_PRODUCT_SCAN_LABEL_ANALYZING,
  PATH_TRACKER_DESCRIBE_ADD_INGREDIENT_ADD_PRODUCT,
  PATH_TRACKER_DESCRIBE_ADD_INGREDIENT_ADD_PRODUCT_SCAN_LABEL,
  PATH_TRACKER_DESCRIBE_ADD_INGREDIENT_ADD_PRODUCT_SCAN_LABEL_ANALYZING,
} from './paths';
import { DIET_TYPES_PT, DIET_TYPES_EN } from '../GoalSettings/consts';
import {
  TrackerIndexPage,
  TrackerSettingsPage,
  MacroSettingsPage,
  TrackerMealPage,
  TrackerAddIngredientPage,
  TrackerDescribeMealPage,
  TrackerDescribeManualMealPage,
  TrackerDescribeMealVoicePage,
  TrackerAddDescribeMealPage,
  TrackerDescribeActivityPage,
  TrackerDescribeActivityVoicePage,
  TrackerAddActivityPage,
  TrackerEditActivityPage,
  TrackerScanPlatePage,
  TrackerScanPlateDetailsPage,
  TrackerScanBarCodePage,
  TrackerScanBarCodeIngredientPage,
  TrackerActivityPhotoCapturePage,
  TrackerAddUserProductPage,
  TrackerScanLabelPage,
  TrackerScanLabelAnalyzingPage,
} from '@front-activerse/modules';
import { trackerArticleId } from './consts';
import { fetchRemoteConfigFields } from '../Firebase/firebaseRemoteConfig';
import { markNotificationAsClosed, getClosedNotifications } from '../Firebase/firebaseFirestoreDb';

const dummy_t = (translationKey: string) => translationKey;

const activeLang = localStorage.getItem('i18nextLng');

const descendantRoutes: Route[] = [
  {
    path: PATH_TRACKER,
    element: (
      <TrackerIndexPage
        trackerArticleId={trackerArticleId}
        fetchRemoteConfigFields={fetchRemoteConfigFields}
        getClosedNotifications={getClosedNotifications}
        markNotificationAsClosed={markNotificationAsClosed}
      />
    ),
    private: true,
    title: dummy_t('tracker.details.navbarTitle'),
    mobileAppTabIdentifier: '',
  },
  {
    path: PATH_TRACKER_SETTINGS,
    element: (
      <TrackerSettingsPage dietTypes={activeLang === 'pt-BR' ? DIET_TYPES_PT : DIET_TYPES_EN} />
    ),
    private: true,
    title: dummy_t('trackerSettings.navbarTitle'),
    mobileAppTabIdentifier: '',
  },
  {
    path: PATH_TRACKER_SETTINGS_MACRO,
    element: <MacroSettingsPage />,
    private: true,
    title: dummy_t('tracker.macroSettings.navbarTitile'),
    mobileAppTabIdentifier: '',
  },
  {
    path: PATH_TRACKER_MEAL,
    element: <TrackerMealPage />,
    private: true,
    title: 'tracker.mealDetails.navbarTitle',
    mobileAppTabIdentifier: 'diet',
  },
  {
    path: PATH_TRACKER_ADD_INGREDIENT,
    element: <TrackerAddIngredientPage />,
    private: true,
    title: 'tracker.logMeal.addIngredient.navbarTitle',
    mobileAppTabIdentifier: 'diet',
  },
  {
    path: PATH_TRACKER_ADD_INGREDIENT_SCAN_BARCODE,
    element: <TrackerScanBarCodeIngredientPage />,
    private: true,
    title: 'tracker.scanBarcode.navbarTitle',
    mobileAppTabIdentifier: 'diet',
  },
  {
    path: PATH_TRACKER_DESCRIBE_MEAL,
    element: <TrackerDescribeMealPage />,
    private: true,
    title: 'tracker.describeFood.navbar.Title',
    mobileAppTabIdentifier: 'diet',
  },
  {
    path: PATH_TRACKER_DESCRIBE_MANUAL_MEAL,
    element: <TrackerDescribeManualMealPage />,
    private: true,
    title: 'tracker.logMeal.navbarTitle',
    mobileAppTabIdentifier: 'diet',
  },
  {
    path: PATH_TRACKER_DESCRIBE_MEAL_VOICE,
    element: <TrackerDescribeMealVoicePage />,
    private: true,
    title: 'tracker.describeFood.byVoice.navbarTitle',
    mobileAppTabIdentifier: 'diet',
  },
  {
    path: PATH_TRACKER_DESCRIBE_ACTIVITY,
    element: <TrackerDescribeActivityPage />,
    private: true,
    title: 'tracker.describeActivity.navbar.title',
    mobileAppTabIdentifier: 'diet',
  },
  {
    path: PATH_TRACKER_DESCRIBE_ACTIVITY_VOICE,
    element: <TrackerDescribeActivityVoicePage />,
    private: true,
    title: 'tracker.describeFood.byVoice.navbarTitle',
    mobileAppTabIdentifier: 'diet',
  },
  {
    path: PATH_TRACKER_DESCRIBE_ACTIVITY_ACTIVITY_DETAILS,
    element: <TrackerAddActivityPage />,
    private: true,
    title: 'tracker.logItem.navbarTitle',
    mobileAppTabIdentifier: 'diet',
  },
  {
    path: PATH_TRACKER_EDIT_ACTIVITY,
    element: <TrackerEditActivityPage />,
    private: true,
    title: 'tracker.activityDetails.navbarTitle',
    mobileAppTabIdentifier: 'diet',
  },
  {
    path: PATH_TRACKER_SCAN_PLATE,
    element: <TrackerScanPlatePage />,
    private: true,
    title: 'tracker.scanPlate.navbarTitle',
    mobileAppTabIdentifier: 'diet',
  },
  {
    path: PATH_TRACKER_SCAN_PLATE_DETAILS,
    element: <TrackerScanPlateDetailsPage />,
    private: true,
    title: 'tracker.analizeMeal.ingredients.navbarTitle',
    mobileAppTabIdentifier: 'diet',
  },
  {
    path: PATH_TRACKER_SCAN_BARCODE,
    element: <TrackerScanBarCodePage />,
    private: true,
    title: 'tracker.scanBarcode.navbarTitle',
    mobileAppTabIdentifier: 'diet',
  },
  {
    path: PATH_TRACKER_DESCRIBE_ADD_INGREDIENT,
    element: <TrackerAddIngredientPage />,
    private: true,
    title: 'tracker.logMeal.addIngredient.navbarTitle',
    mobileAppTabIdentifier: 'diet',
  },
  {
    path: PATH_TRACKER_DESCRIBE_ADD_INGREDIENT_SCAN_BARCODE,
    element: <TrackerScanBarCodeIngredientPage />,
    private: true,
    title: 'tracker.scanBarcode.navbarTitle',
    mobileAppTabIdentifier: 'diet',
  },
  {
    path: PATH_TRACKER_DESCRIBE_MEAL_MEAL,
    element: <TrackerAddDescribeMealPage />,
    private: true,
    title: 'tracker.logMeal.navbarTitle',
    mobileAppTabIdentifier: 'diet',
  },
  {
    path: PATH_TRACKER_UPLOAD_IMAGE,
    element: <TrackerActivityPhotoCapturePage />,
    private: true,
    title: '',
    mobileAppTabIdentifier: 'diet',
  },
  {
    path: PATH_TRACKER_ADD_PRODUCT,
    element: <TrackerAddUserProductPage />,
    private: true,
    title: 'tracker.addProduct.navbarTitle',
    mobileAppTabIdentifier: 'diet',
  },
  {
    path: PATH_TRACKER_SCAN_LABEL,
    element: (
      <TrackerScanLabelPage
        getClosedNotifications={getClosedNotifications}
        markNotificationAsClosed={markNotificationAsClosed}
      />
    ),
    private: true,
    title: 'tracker.scanLabel.navbarTitle',
    mobileAppTabIdentifier: 'diet',
  },
  {
    path: PATH_TRACKER_SCAN_LABEL_ANALYZING,
    element: <TrackerScanLabelAnalyzingPage />,
    private: true,
    title: 'tracker.scanLabel.navbarTitle',
    mobileAppTabIdentifier: 'diet',
  },
  {
    path: PATH_TRACKER_ADD_INGREDIENT_ADD_PRODUCT,
    element: <TrackerAddUserProductPage />,
    private: true,
    title: 'tracker.addProduct.navbarTitle',
    mobileAppTabIdentifier: 'diet',
  },
  {
    path: PATH_TRACKER_ADD_INGREDIENT_ADD_PRODUCT_SCAN_LABEL,
    element: (
      <TrackerScanLabelPage
        getClosedNotifications={getClosedNotifications}
        markNotificationAsClosed={markNotificationAsClosed}
      />
    ),
    private: true,
    title: 'tracker.scanLabel.navbarTitle',
    mobileAppTabIdentifier: 'diet',
  },
  {
    path: PATH_TRACKER_ADD_INGREDIENT_ADD_PRODUCT_SCAN_LABEL_ANALYZING,
    element: <TrackerScanLabelAnalyzingPage />,
    private: true,
    title: 'tracker.scanLabel.navbarTitle',
    mobileAppTabIdentifier: 'diet',
  },
  {
    path: PATH_TRACKER_DESCRIBE_ADD_INGREDIENT_ADD_PRODUCT,
    element: <TrackerAddUserProductPage />,
    private: true,
    title: 'tracker.addProduct.navbarTitle',
    mobileAppTabIdentifier: 'diet',
  },
  {
    path: PATH_TRACKER_DESCRIBE_ADD_INGREDIENT_ADD_PRODUCT_SCAN_LABEL,
    element: (
      <TrackerScanLabelPage
        getClosedNotifications={getClosedNotifications}
        markNotificationAsClosed={markNotificationAsClosed}
      />
    ),
    private: true,
    title: 'tracker.scanLabel.navbarTitle',
    mobileAppTabIdentifier: 'diet',
  },
  {
    path: PATH_TRACKER_DESCRIBE_ADD_INGREDIENT_ADD_PRODUCT_SCAN_LABEL_ANALYZING,
    element: <TrackerScanLabelAnalyzingPage />,
    private: true,
    title: 'tracker.scanLabel.navbarTitle',
    mobileAppTabIdentifier: 'diet',
  },
];

export default descendantRoutes;
